import { Navigate, useLocation } from 'react-router-dom';
import PATH from './path';

interface ProtectRouterProps {
  children: React.ReactElement;
  auth: {
    isLogin: boolean;
  };
}

const ProtectRouter = ({ auth, children }: ProtectRouterProps) => {
  const { pathname, search } = useLocation();

  if (!auth.isLogin) {
    const requestedPath = `${pathname}${search}`;
    const signInPath = `${PATH.auth.signIn}?path=${encodeURIComponent(requestedPath)}`;

    return <Navigate to={signInPath} replace />;
  }

  return children;
};

export default ProtectRouter;
